import React from 'react';
import { Button } from '@mui/material';
import { useGuardedNavigation } from '../../../permissions/useGuardedNavigation';

export default function PartnerListPageActions() {
  const { navigateCreate } = useGuardedNavigation('partners');

  return (
    <Button variant="contained" color="primary" onClick={navigateCreate}>
      + Create New Partner
    </Button>
  );
}
